/** @jsxImportSource @emotion/react */
import Loader from "../components/MainComponents/Loader/Loader";
import { css, useTheme } from "@emotion/react";
import { useChangeLogService } from "services/useChangeLogService";
import { Icon } from "@coreai/component-library";
import { useLanguage } from "LanguageContext";
import { useState } from "react";
import ReactMarkdown from "react-markdown";

export default function AboutPage() {
  const theme = useTheme();
  const { t } = useLanguage();
  const { changeLogData, loading, error } = useChangeLogService();
  const [showMore, setShowMore] = useState(false);
  const titleStyles = css`
    font-size: ${theme.typography.heading2_semiBold.fontSize};
    margin-top: ${theme.spacing["5xl"]};
    margin-bottom: ${theme.spacing.xl};
    font-family: ${theme.typography.heading2_semiBold.fontFamily};
    font-weight: ${theme.typography.heading2_semiBold.fontWeight};
    color: ${theme.colors.textMedium};
  `;

  const subtitleStyles = css`
    font-size: ${theme.typography.heading3_medium.fontSize};
    margin-top: ${theme.spacing.xl};
    margin-bottom: ${theme.spacing.xl};
    font-family: ${theme.typography.heading3_medium.fontFamily};
    font-weight: ${theme.typography.heading3_medium.fontWeight};
    color: ${theme.colors.textDark};
  `;

  const paragrapheStyles = css`
    font-size: ${theme.typography.bodyMedium.fontSize};
    margin-top: ${theme.spacing.xl};
    margin-bottom: ${theme.spacing.xl};
    font-family: ${theme.typography.bodyMedium.fontFamily};
    font-weight: ${theme.typography.bodyMedium.fontWeight};
    color:${theme.colors.blackGray};
  `;

  const introductionSectionStyles = css`
    text-decoration: none;
    border-radius: ${theme.radius.sm};
    position: relative;
    background-color: #fff;
    color: inherit;
    padding: ${theme.spacing.xl} ${theme.spacing["5xl"]} ${theme.spacing.xl}
      ${theme.spacing["5xl"]};
    position: relative;
    font-size: 20px;
    text-align: left;
    margin-top: ${theme.spacing["4xl"]};
  `;

  const changeLogSectionStyles = css`
    text-decoration: none;
    border-radius: ${theme.radius.sm};
    position: relative;
    background-color: #fff;
    color: inherit;
    padding: ${theme.spacing.xl} ${theme.spacing["5xl"]} ${theme.spacing.xl}
      ${theme.spacing["5xl"]};
    position: relative;
    font-size: 20px;
    text-align: left;
    margin-top: ${theme.spacing["4xl"]};
  `;

  const dateTitleStyles = css`
    font-size: ${theme.typography.heading4_semiBold.fontSize};
    font-weight: ${theme.typography.heading4_semiBold.fontWeight};
    margin-bottom: ${theme.spacing.xxl};
    color: ${theme.colors.textDark};
  `;
  const logItemStyles = css`
    display: flex;
    align-items: flex-start;
    margin-bottom: ${theme.spacing.xl};
  `;

  const badgeContainerStyles = css`
    flex: 0 0 80px;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const badgeStyles = css`
    color: white;
    font-size: 12px;
    font-famity: Inter;
    line-height: 18px;
    width: 77px;
    font-weight: 600;
    border-radius: 4px;
    padding: ${theme.spacing.xs} ${theme.spacing.sm};
    text-align: center;
  `;

  const badgeImprovedStyles = css`
    background-color: ${theme.colors.textMedium};
  `;

  const badgeNewStyles =css`
    background-color: ${theme.colors.primary};
  `;

  const badgeFixedStyles = css`
    background-color: ${theme.colors.white};
    color: ${theme.colors.feedbackTitleColor};
    border: 1px solid var(--Borders-border-tertiary,  ${theme.colors.strokeGrayTable})
  `;

  const badgeColors: Record<string, any> = {
    New: badgeNewStyles,       // primary
    Update: badgeImprovedStyles, // primary-invert
    Fix: badgeFixedStyles,       // quaternary
  };

  const logTextStyles = css`
    flex: 1;
    font-size: ${theme.typography.bodyMedium.fontSize};
    color: ${theme.colors.textDark};
    margin-left: ${theme.spacing.lg};
  `;

  const borderLinke = css`
  width: 100%;
  margin-bottom: 10px;
  border: 1px solid ${theme.colors.strokeGrayTable};
  `;

  const iconStyle = css`
    color: ${theme.colors.primary};
  `;

  const showMoreStyle = css`
  display: flex;
  justify-content: right;
  align-items: center;
  `;

  const moreTitleStyle = css`
  margin-top: 0px;
  font-weight: 600;
  color: ${theme.colors.primary};
  `;

  const showButtonStyle = css`
    cursor: pointer;
    display: flex;
    align-item: center;
    gap: 4px;
  `;
  
  if (loading) return <div className="loaderPage"> <Loader /> </div>;
  if (error) return <div className="loaderPage"> <div>Error</div> </div>;
  return (
    <>
      <div>
       {changeLogData?.pageTitle && <div css={titleStyles}>{changeLogData?.pageTitle}</div>}      
        
       {(changeLogData?.subtitle1 || changeLogData?.paragraph) && <div css={introductionSectionStyles}>
       {changeLogData?.subtitle1 &&  <div css={subtitleStyles}>{changeLogData?.subtitle1}</div>}
          {changeLogData?.paragraph && <ReactMarkdown
                className="reference-card-description"
                components={{
                  a: ({ href, children }) => (
                    <a href={href} target="_blank">
                      {children}
                    </a>
                  ),
                }}
              >
              {changeLogData?.paragraph}
              </ReactMarkdown>
          }
        </div>
        }
        {(changeLogData?.subtitle2!=="" || (changeLogData?.dates_about && changeLogData?.dates_about?.length  > 0)) && 
        <div css={changeLogSectionStyles}>
         {changeLogData?.subtitle2 && <div css={subtitleStyles}>{changeLogData?.subtitle2}</div>}

          {changeLogData?.dates_about?.sort((a, b) => a?.position - b?.position) 
            .slice(0, showMore ? changeLogData?.dates_about.length : 2)
            .map((dateLog) => (
            <div key={dateLog?.id}>
              <div css={dateTitleStyles}>{dateLog?.title}</div>
              {dateLog?.items_change_logs?.sort((x, y) => x?.position - y?.position).map((item) => (
                <div key={item.id} css={logItemStyles}>
                  <div css={badgeContainerStyles}>
                    <div css={[badgeStyles, badgeColors[item?.badge]]}>
                      {item?.badge}
                    </div>
                  </div>
                  <div css={logTextStyles}>{item?.title}</div>
                </div>
              ))}
              <div>
              <div css={borderLinke} />
                </div>
            </div>
          ))}

          {changeLogData?.dates_about && changeLogData?.dates_about?.length > 2 && (
            <div css={showMoreStyle}>
                <div css={showButtonStyle} onClick={() => setShowMore((prev) => !prev)}>
                  {!showMore ? <Icon name="download-02" size="md" css={iconStyle}/> : <Icon name="upload-02" size="md" css={iconStyle}/>}
                  <p css={moreTitleStyle}>{!showMore ? t("response_collapseToggleSee_more") : t("response_collapseToggleSee_less")}</p>
                </div>
            </div>
          )}
        </div>
      }
      </div>
    </>
  );
}
